import { GroupNameDto, StringReplacement } from '../../models';

export function getNewGroup(group: GroupNameDto, groups: GroupNameDto[], groupsRename: StringReplacement[]): GroupNameDto {
    if (group && groupsRename && groupsRename.length) {
        let newGroupName = group.uniqueName;
        groupsRename.forEach(n => newGroupName = newGroupName.replace(n.oldValue, n.newValue));
        const found = groups.find(g => g.uniqueName === newGroupName);
        if (found) {
            group = found;
        } else {
            group = { uniqueName: newGroupName } as GroupNameDto;
        }
    }
    return group;
}